/* Inline Design Lab for one product: Gildan 64000 Softstyle tee.
   Draft theme only. The print area is invisible: no dashed box or outline.
   Size caps and the default position still use that area.
   Uploaded art keeps a real inch size. The mockup photo scales with the
   preview size so a fixed print looks larger on a smaller shirt.
   Uploaded art can sit partly or fully outside it.
   Does not attach files to the cart. No text or clipart tools.
   Youth XS full-print width is 10.5 in: Gildan 64000B flat chest is 14 in,
   and the printable width is that chest minus 1.75 in on each side.
   Chest, sleeve, and nape use the location sizes in ezink-artwork-upload.js.
   Sleeve locations use a real side photo when that color has one.
   Otherwise a neutral template for this style is tinted with the swatch
   hex (multiply). Those templates are marked Approximate and are Shopify
   Files, never product-gallery images. Add another style under
   SLEEVE_STYLES when it gets its own left and right template. */
(function (root) {
  var HANDLE = "gildan-64000-unisex-softstyle-tee";
  var SIDE_MARGIN = 1.75;
  var SHEET_MAX_W = 16.5;
  var FRONT_MAX_H = 14;
  var BACK_MAX_H = 16.5;
  var VERTICAL_RESERVE = 8;
  var TORSO_FRAC = 0.48;
  var PROOF_LABEL = "Approximate mockup - not a final proof";
  var MIN_DPI = 150;
  /* Flat chest (laid flat, one inch below the armhole) and body length at
     the back, in inches. Adult rows are the Gildan published 64000 spec
     sheet (XS 16×27 through 5XL 32×35). Youth rows are the Gildan published
     64000B spec sheet (XS chest 14, length 18). The product size chart on
     the page replaces these when it has a chest-width row. */
  var SPEC_SOURCE = "Gildan published 64000 spec sheet (chest laid flat, body length at back) and 64000B youth sheet";
  var SIZE_ORDER = ["YXS", "YS", "YM", "YL", "YXL", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
  var CHART = null;

  var BODY = {
    YXS: { w: 14, len: 18, label: "Youth XS" },
    YS: { w: 16, len: 20.5, label: "Youth S" },
    YM: { w: 17, len: 22, label: "Youth M" },
    YL: { w: 18, len: 23.5, label: "Youth L" },
    YXL: { w: 19, len: 25, label: "Youth XL" },
    XS: { w: 16, len: 27, label: "XS" },
    S: { w: 18, len: 28, label: "S" },
    M: { w: 20, len: 29, label: "M" },
    L: { w: 22, len: 30, label: "L" },
    XL: { w: 24, len: 31, label: "XL" },
    "2XL": { w: 26, len: 32, label: "2XL" },
    "3XL": { w: 28, len: 33, label: "3XL" },
    "4XL": { w: 30, len: 34, label: "4XL" },
    "5XL": { w: 32, len: 35, label: "5XL" }
  };

  var FIXED = {
    "left chest": { w: 4, h: 4, view: "front", anchor: "left-chest" },
    "right chest": { w: 4, h: 4, view: "front", anchor: "right-chest" },
    "left sleeve": { w: 2.5, h: 2.5, view: "side", anchor: "left-sleeve" },
    "right sleeve": { w: 2.5, h: 2.5, view: "side", anchor: "right-sleeve" },
    nape: { w: 2.5, h: 2.5, view: "back", anchor: "nape" }
  };

  var ANCHOR = {
    front: { cx: 50, top: 23 },
    back: { cx: 50, top: 16 },
    "left-chest": { cx: 62, top: 24 },
    "right-chest": { cx: 38, top: 24 },
    "left-sleeve": { cx: 84, top: 30 },
    "right-sleeve": { cx: 16, top: 30 },
    nape: { cx: 50, top: 12 }
  };


  /* Per-style sleeve fallback. Photo placement is for this style's real
     side shots (3/4 view, both sleeves). Template placement is the neutral
     profile file. shadeMid is the flat-fabric grey the multiply uses. */
  var SLEEVE_STYLES = {
    "gildan-64000-unisex-softstyle-tee": {
      shadeMid: 208,
      colors: {
      "antique cherry red": "#a51631",
      "antique heliconia": "#bd4482",
      "antique sapphire": "#016a91",
      "azalea": "#fc89a5",
      "black": "#28292d",
      "cardinal red": "#971c34",
      "carolina blue": "#96b6e6",
      "charcoal": "#666666",
      "cherry red": "#b61d3f",
      "coral silk": "#fc7673",
      "cornsilk": "#dad185",
      "daisy": "#feca34",
      "dark chocolate": "#4c4240",
      "dark heather": "#5f6b6b",
      "fan candy pink": "#f5aeca",
      "fan dark green": "#1f4032",
      "fan deep royal": "#152e72",
      "fan marine green": "#0b4547",
      "fan texas orange": "#a6502e",
      "forest": "#2c4035",
      "garnet": "#731f2f",
      "gold": "#febd22",
      "graphite heather": "#959096",
      "heather berry": "#dd6d9f",
      "heather cardinal red": "#d36b7a",
      "heather dark grey": "#676767",
      "heather galapagos blue": "#42a4b8",
      "heather heliconia": "#fb75a3",
      "heather indigo": "#838cac",
      "heather irish green": "#049d6a",
      "heather maroon": "#805a65",
      "heather military green": "#8e8e7c",
      "heather navy": "#5d6071",
      "heather oatmeal": "#ded3c3",
      "heather orange": "#fc805f",
      "heather purple": "#6f5e92",
      "heather radiant orchid": "#e298c6",
      "heather red": "#e04f65",
      "heather royal": "#729bdd",
      "heather sapphire": "#4ba8c8",
      "heliconia": "#cd5092",
      "ice grey": "#e3d9d8",
      "indigo blue": "#5f7a94",
      "iris": "#558cc8",
      "irish green": "#049d60",
      "jade dome": "#01a3ac",
      "kelly green": "#00b98d",
      "kiwi": "#94b46c",
      "light blue": "#c7dced",
      "light pink": "#f8cccf",
      "lime": "#a2e273",
      "maroon": "#632435",
      "metro blue": "#4e5989",
      "military green": "#636250",
      "mint green": "#bae8bd",
      "natural": "#e1d2bf",
      "navy": "#273046",
      "neon blue": "#005daa",
      "off white": "#efecdf",
      "orange": "#fd6f4c",
      "paragon": "#bfa1ad",
      "pistachio": "#d1deba",
      "prairie dust": "#95876d",
      "purple": "#492a6e",
      "red": "#c9182e",
      "royal": "#2267cb",
      "sage": "#abb8a4",
      "sand": "#cdbdae",
      "sapphire": "#0192be",
      "sky": "#b6e5f7",
      "sport grey": "#acacae",
      "stone blue": "#9eafbf",
      "tropical blue": "#198796",
      "turf green": "#037c49",
      "white": "#f5f5f7"
      },
      photo: {
        bodyFrac: 0.91,
        imgW: 500,
        imgH: 625,
        left: { cx: 79, cy: 27 },
        right: { cx: 16, cy: 27 }
      },
      left: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-64000-left-sleeve-template.png?v=1792564615",
        cx: 62,
        cy: 30,
        bodyFrac: 0.891,
        imgW: 864,
        imgH: 1152
      },
      right: {
        url: "https://cdn.shopify.com/s/files/1/0424/6211/8055/files/ezink-64000-right-sleeve-template.png?v=1792564618",
        cx: 38,
        cy: 30,
        bodyFrac: 0.891,
        imgW: 864,
        imgH: 1152
      }
    }
  };

  function parseHex(hex) {
    var h = String(hex || "").replace("#", "").trim();
    if (h.length === 3) h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  function clamp255(n) {
    n = Math.round(Number(n) || 0);
    if (n < 0) return 0;
    if (n > 255) return 255;
    return n;
  }

  /* Multiply the light-grey shading by the swatch. grey 208 is the flat fabric. */
  function tintChannels(grey, hex, mid) {
    var rgb = parseHex(hex);
    if (!rgb) return null;
    var f = Number(grey) / (Number(mid) || 208);
    return [clamp255(rgb[0] * f), clamp255(rgb[1] * f), clamp255(rgb[2] * f)];
  }

  function swatchHex(handle, color) {
    var style = SLEEVE_STYLES[handle];
    if (!style || !style.colors) return "";
    return style.colors[String(color || "").trim().toLowerCase()] || "";
  }

  function isSleeveView(view, side) {
    var v = String(view || "").toLowerCase().trim();
    if (!v || v.indexOf("front") === 0 || v.indexOf("back") === 0 || v.indexOf("on-model") >= 0) return false;
    if (v.indexOf("sleeve") < 0 && v !== "side" && v.indexOf("side") !== 0) return false;
    if (side === "left" && v.indexOf("right") === 0) return false;
    if (side === "right" && v.indexOf("left") === 0) return false;
    return true;
  }

  function chooseSleeve(handle, side, views) {
    var named = "";
    var generic = "";
    var list = views || [];
    var i;
    for (i = 0; i < list.length; i++) {
      var v = String(list[i] || "").toLowerCase();
      if (!isSleeveView(v, side)) continue;
      if (v.indexOf(side) >= 0) named = v;
      else if (!generic) generic = v;
    }
    if (named || generic) return { kind: "photo", view: named || generic };
    var style = SLEEVE_STYLES[handle];
    if (style && style[side] && style[side].url) return { kind: "template", side: side };
    return { kind: "none" };
  }

  function sleeveGeom(handle, side, kind) {
    var style = SLEEVE_STYLES[handle];
    if (!style) return null;
    if (kind === "photo" && style.photo && style.photo[side]) {
      return {
        cx: style.photo[side].cx,
        cy: style.photo[side].cy,
        bodyFrac: style.photo.bodyFrac,
        imgW: style.photo.imgW,
        imgH: style.photo.imgH
      };
    }
    var tmpl = style[side];
    if (kind === "template" && tmpl) {
      return {
        cx: tmpl.cx,
        cy: tmpl.cy,
        bodyFrac: tmpl.bodyFrac,
        imgW: tmpl.imgW,
        imgH: tmpl.imgH
      };
    }
    return null;
  }

  /* Box is  area inches tall on a photo whose garment height is body length. */
  function sleeveBox(size, areaW, areaH, geom) {
    var body = bodyFor(size);
    var widthPct = (areaW / body.len) * geom.bodyFrac * (geom.imgH / geom.imgW) * 100;
    var heightPct = (areaH / body.len) * geom.bodyFrac * 100;
    return {
      widthPct: widthPct,
      left: geom.cx - widthPct / 2,
      top: geom.cy - heightPct / 2
    };
  }

  function roundIn(n) {
    return Math.round((Number(n) + 1e-9) * 10) / 10;
  }

  function normalizeSize(raw, youthProduct) {
    var s = String(raw || "").trim().toUpperCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");
    if (s === "YOUTH XS" || s === "YXS" || s === "YS XS") return "YXS";
    if (s === "YOUTH S" || s === "YS") return "YS";
    if (s === "YOUTH M" || s === "YM") return "YM";
    if (s === "YOUTH L" || s === "YL") return "YL";
    if (s === "YOUTH XL" || s === "YXL") return "YXL";
    if (s === "XXL") return "2XL";
    if (s === "XXXL") return "3XL";
    if (youthProduct) {
      if (s === "XS") return "YXS";
      if (s === "S") return "YS";
      if (s === "M") return "YM";
      if (s === "L") return "YL";
      if (s === "XL") return "YXL";
    }
    if (BODY[s]) return s;
    return youthProduct ? "YXS" : "M";
  }

  function locKey(name) {
    var s = String(name || "front").toLowerCase().replace(/\s+\d+$/, "").trim();
    if (s === "full front" || s === "center front" || s === "front") return "front";
    if (s === "full back" || s === "back") return "back";
    if (s === "left chest" || s === "lc") return "left chest";
    if (s === "right chest" || s === "rc") return "right chest";
    if (s === "left sleeve") return "left sleeve";
    if (s === "right sleeve") return "right sleeve";
    if (s === "nape" || s === "yoke") return "nape";
    return "other";
  }

  function garmentMaxWidth(body) {
    return roundIn(Math.min(SHEET_MAX_W, Math.max(2, body.w - SIDE_MARGIN * 2)));
  }

  function heightRoom(body, cap) {
    return roundIn(Math.min(cap, Math.max(6, body.len - VERTICAL_RESERVE)));
  }

  function printArea(sizeRaw, location, opts) {
    opts = opts || {};
    var size = normalizeSize(sizeRaw, !!opts.youth);
    var body = bodyFor(size);
    var maxW = garmentMaxWidth(body);
    var key = locKey(location);
    var fixed = FIXED[key];
    if (fixed) {
      var w = fixed.w;
      var h = fixed.h;
      if (w > maxW) {
        h = roundIn(h * (maxW / w));
        w = maxW;
      }
      return {
        w: w,
        h: h,
        view: fixed.view,
        anchor: fixed.anchor,
        size: size,
        sizeLabel: body.label,
        key: key
      };
    }
    var view = key === "back" ? "back" : "front";
    var anchor = key === "back" ? "back" : "front";
    var width = key === "other" ? roundIn(Math.min(8, maxW)) : maxW;
    var height = key === "back" ? heightRoom(body, BACK_MAX_H) : heightRoom(body, key === "other" ? 8 : FRONT_MAX_H);
    if (key === "other") height = roundIn(Math.min(height, width));
    return {
      w: width,
      h: height,
      view: view,
      anchor: anchor,
      size: size,
      sizeLabel: body.label,
      key: key
    };
  }

  function clampPlacement(boxW, boxH, natW, natH, x, y, wPct) {
    if (!(natW > 0) || !(natH > 0) || !(boxW > 0) || !(boxH > 0)) {
      return { x: 50, y: 50, wPct: 70 };
    }
    var aspect = natW / natH;
    var wpx = (wPct / 100) * boxW;
    var hpx = wpx / aspect;
    if (hpx > boxH) {
      hpx = boxH;
      wpx = hpx * aspect;
    }
    if (wpx > boxW) {
      wpx = boxW;
      hpx = wpx / aspect;
    }
    var minW = Math.min(boxW, boxH * aspect) * 0.08;
    if (wpx < minW) {
      wpx = minW;
      hpx = wpx / aspect;
      if (hpx > boxH) {
        hpx = boxH;
        wpx = hpx * aspect;
      }
    }
    /* x and y are not pulled back into the print area. Placement stays free. */
    return {
      x: x,
      y: y,
      wPct: (wpx / boxW) * 100
    };
  }

  function widthInches(wPct, areaW) {
    return roundIn((wPct / 100) * areaW);
  }

  function bodyFor(size) {
    var key = BODY[size] ? size : "M";
    var base = BODY[key];
    var over = CHART && CHART[key];
    if (!over) return base;
    return {
      w: over.w > 0 ? over.w : base.w,
      len: over.len > 0 ? over.len : base.len,
      label: over.label || base.label
    };
  }

  function knownSize(raw, youthProduct) {
    var s = String(raw || "").trim().toUpperCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");
    if (!s || s === "SIZE") return "";
    if (s === "YOUTH XS" || s === "YXS" || s === "YS XS") return "YXS";
    if (s === "YOUTH S" || s === "YS") return "YS";
    if (s === "YOUTH M" || s === "YM") return "YM";
    if (s === "YOUTH L" || s === "YL") return "YL";
    if (s === "YOUTH XL" || s === "YXL") return "YXL";
    if (s === "XXL") return "2XL";
    if (s === "XXXL") return "3XL";
    if (youthProduct) {
      if (s === "XS") return "YXS";
      if (s === "S") return "YS";
      if (s === "M") return "YM";
      if (s === "L") return "YL";
      if (s === "XL") return "YXL";
    }
    if (BODY[s]) return s;
    return "";
  }

  function parseInches(raw) {
    var s = String(raw == null ? "" : raw).replace(/["″]/g, "").trim();
    var mixed = s.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)/);
    if (mixed) return Number(mixed[1]) + Number(mixed[2]) / Number(mixed[3]);
    var frac = s.match(/^(\d+)\s*\/\s*(\d+)/);
    if (frac) return Number(frac[1]) / Number(frac[2]);
    var n = parseFloat(s);
    return n > 0 ? n : 0;
  }

  function specKind(name) {
    var s = String(name || "").toLowerCase().replace(/\s+/g, " ").trim();
    if (!s || /sleeve|shoulder|neck|collar|hem|tolerance/.test(s)) return "";
    if (/chest|body width|width \(laid flat\)|laid flat/.test(s)) return "w";
    if (/body length|^length\b|length at back/.test(s)) return "len";
    return "";
  }

  function parseSizeChart(headers, rows) {
    if (!headers || headers.length < 2 || !rows || !rows.length) return null;
    var widthRow = null;
    var lenRow = null;
    var i;
    for (i = 0; i < rows.length; i++) {
      var kind = specKind(rows[i] && rows[i][0]);
      if (kind === "w" && !widthRow) widthRow = rows[i];
      if (kind === "len" && !lenRow) lenRow = rows[i];
    }
    if (!widthRow) return null;
    var out = {};
    var found = false;
    for (i = 1; i < headers.length; i++) {
      var size = knownSize(headers[i], false);
      if (!size) size = knownSize(headers[i], true);
      if (!size || out[size]) continue;
      var w = parseInches(widthRow[i]);
      if (!(w > 0)) continue;
      var len = lenRow ? parseInches(lenRow[i]) : 0;
      var base = BODY[size];
      out[size] = {
        w: w,
        len: len > 0 ? len : (base ? base.len : 0),
        label: base ? base.label : String(headers[i])
      };
      found = true;
    }
    return found ? out : null;
  }

  function applySpecChart(headers, rows) {
    CHART = parseSizeChart(headers, rows);
    return CHART;
  }

  function clearSpecChart() {
    CHART = null;
  }

  function specSource() {
    return CHART ? "product size chart" : SPEC_SOURCE;
  }

  function offeredSizes(labels, youthProduct) {
    var seen = {};
    var i;
    for (i = 0; i < (labels || []).length; i++) {
      var size = knownSize(labels[i], !!youthProduct);
      if (size) seen[size] = true;
    }
    return SIZE_ORDER.filter(function (s) { return seen[s]; });
  }

  function defaultPreviewSize(sizes) {
    var list = sizes || [];
    if (list.indexOf("M") >= 0) return "M";
    if (list.indexOf("YM") >= 0) return "YM";
    return list.length ? list[0] : "M";
  }

  function referenceWidth(sizes) {
    var list = sizes && sizes.length ? sizes : ["5XL"];
    var max = 0;
    var i;
    for (i = 0; i < list.length; i++) {
      var body = bodyFor(list[i]);
      if (body && body.w > max) max = body.w;
    }
    return max || bodyFor("M").w;
  }

  /* Chest pixels on the mockup divided by the flat chest width. */
  function pixelsPerInch(photoWidthPx, bodyWidthIn, torsoFrac) {
    var frac = torsoFrac == null ? TORSO_FRAC : torsoFrac;
    if (!(photoWidthPx > 0) || !(bodyWidthIn > 0) || !(frac > 0)) return 0;
    return (photoWidthPx * frac) / bodyWidthIn;
  }

  function artPixels(inches, ppi) {
    return (Number(inches) || 0) * (Number(ppi) || 0);
  }

  function coverage(artInches, bodyWidthIn) {
    if (!(bodyWidthIn > 0)) return 0;
    return (Number(artInches) || 0) / bodyWidthIn;
  }

  /* Garment drawing scale against the widest offered size, at a fixed PPI. */
  function shirtScale(bodyW, refW) {
    if (!(bodyW > 0) || !(refW > 0)) return 1;
    return bodyW / refW;
  }

  function fitInches(inchW, natW, natH, maxW, maxH) {
    var aspect = natW > 0 && natH > 0 ? natW / natH : 1;
    var w = Number(inchW);
    if (!(w > 0) || w < 0.5) w = 0.5;
    var h = w / aspect;
    if (maxW > 0 && w > maxW) {
      w = maxW;
      h = w / aspect;
    }
    if (maxH > 0 && h > maxH) {
      h = maxH;
      w = h * aspect;
    }
    if (maxW > 0 && w > maxW) w = maxW;
    return { w: roundIn(w), h: roundIn(h) };
  }

  function rasterDpi(px, inches) {
    if (!(px > 0) || !(inches > 0)) return 0;
    return px / inches;
  }

  function lowResWarning(px, inches, isVector, minDpi) {
    if (isVector) return "";
    var floor = minDpi || MIN_DPI;
    var dpi = rasterDpi(px, inches);
    if (!(dpi > 0) || dpi + 1e-9 >= floor) return "";
    return "Low resolution: about " + Math.round(dpi) + " DPI at this print size. Aim for " + floor + " DPI or higher.";
  }

  function shouldWarp(key) {
    return key !== "left sleeve" && key !== "right sleeve";
  }

  /* Half-angle of a mild chest cylinder. Small prints return 0. */
  function warpTheta(artW, bodyW) {
    if (!(artW > 0) || !(bodyW > 0)) return 0;
    var radius = bodyW / Math.PI;
    var theta = (artW / 2) / radius;
    if (theta > 1.15) theta = 1.15;
    if (theta < 0.15) return 0;
    return theta;
  }

  /* 1 = flat. Lower means the print's edges pull in. Half of a true cylinder. */
  function edgeSqueeze(theta) {
    var t = Number(theta) || 0;
    if (!(t > 0)) return 1;
    var full = Math.sin(t) / t;
    return 1 - (1 - full) * 0.5;
  }

  function chestWarpNorm(norm, theta) {
    var t = Number(theta) || 0;
    var n = Number(norm) || 0;
    if (n > 1) n = 1;
    if (n < -1) n = -1;
    if (!(t > 0)) return n;
    var s = Math.sin(t);
    if (!(s > 0)) return n;
    return Math.sin(n * t) / s;
  }

  function chestUnwarpNorm(norm, theta) {
    var t = Number(theta) || 0;
    var n = Number(norm) || 0;
    if (n > 1) n = 1;
    if (n < -1) n = -1;
    if (!(t > 0)) return n;
    var s = Math.sin(t);
    if (!(s > 0)) return n;
    var arg = n * s;
    if (arg > 1) arg = 1;
    if (arg < -1) arg = -1;
    return Math.asin(arg) / t;
  }

  function garmentCenterX(sizeRaw, location, opts) {
    var area = printArea(sizeRaw, location, opts);
    if (area.key.indexOf("sleeve") >= 0) return 50;
    var anchor = ANCHOR[area.anchor] || ANCHOR.front;
    var body = bodyFor(area.size);
    var widthPct = (area.w / body.w) * TORSO_FRAC * 100;
    if (!(widthPct > 0)) return 50;
    var boxLeft = anchor.cx - widthPct / 2;
    return ((50 - boxLeft) / widthPct) * 100;
  }

  function snapBandPct(areaW) {
    if (!(areaW > 0)) return 3;
    return (0.35 / areaW) * 100;
  }

  function paintWarp(canvas, img, theta) {
    var w = canvas.width;
    var h = canvas.height;
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, w, h);
    var squeeze = edgeSqueeze(theta);
    var drawW = w * squeeze;
    var ox = (w - drawW) / 2;
    var strips = Math.max(24, Math.min(80, Math.round(drawW / 3)));
    var nw = img.naturalWidth || img.width;
    var nh = img.naturalHeight || img.height;
    var i;
    for (i = 0; i < strips; i++) {
      var d0 = i / strips;
      var d1 = (i + 1) / strips;
      var s0 = (chestUnwarpNorm(d0 * 2 - 1, theta) + 1) / 2;
      var s1 = (chestUnwarpNorm(d1 * 2 - 1, theta) + 1) / 2;
      var sx = s0 * nw;
      var sw = (s1 - s0) * nw;
      if (!(sw > 0)) continue;
      ctx.drawImage(img, sx, 0, sw, nh, ox + d0 * drawW, 0, (d1 - d0) * drawW, h);
    }
  }

  var api = {
    HANDLE: HANDLE,
    PROOF_LABEL: PROOF_LABEL,
    BODY: BODY,
    SLEEVE_STYLES: SLEEVE_STYLES,
    normalizeSize: normalizeSize,
    locKey: locKey,
    printArea: printArea,
    clampPlacement: clampPlacement,
    widthInches: widthInches,
    garmentMaxWidth: garmentMaxWidth,
    swatchHex: swatchHex,
    tintChannels: tintChannels,
    chooseSleeve: chooseSleeve,
    sleeveGeom: sleeveGeom,
    sleeveBox: sleeveBox,
    isSleeveView: isSleeveView,
    SPEC_SOURCE: SPEC_SOURCE,
    MIN_DPI: MIN_DPI,
    bodyFor: bodyFor,
    knownSize: knownSize,
    parseInches: parseInches,
    parseSizeChart: parseSizeChart,
    applySpecChart: applySpecChart,
    clearSpecChart: clearSpecChart,
    specSource: specSource,
    offeredSizes: offeredSizes,
    defaultPreviewSize: defaultPreviewSize,
    referenceWidth: referenceWidth,
    pixelsPerInch: pixelsPerInch,
    artPixels: artPixels,
    coverage: coverage,
    shirtScale: shirtScale,
    fitInches: fitInches,
    rasterDpi: rasterDpi,
    lowResWarning: lowResWarning,
    shouldWarp: shouldWarp,
    warpTheta: warpTheta,
    edgeSqueeze: edgeSqueeze,
    chestWarpNorm: chestWarpNorm,
    chestUnwarpNorm: chestUnwarpNorm,
    garmentCenterX: garmentCenterX,
    snapBandPct: snapBandPct,
    paintWarp: paintWarp
  };
  root.EZINKDesignLab = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;

  if (typeof document === "undefined") return;

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/"/g, "&quot;");
  }

  function isTarget(pdp) {
    if (!pdp || !pdp.getAttribute) return false;
    var handle = pdp.getAttribute("data-ezink-handle") || "";
    if (handle === HANDLE) return true;
    if (!handle && root.location && String(root.location.pathname || "").indexOf("/products/" + HANDLE) >= 0) {
      return true;
    }
    return false;
  }

  function sectionOf(node) {
    var el = node;
    while (el) {
      if (el.id && el.id.indexOf("ProductSection-") === 0) return el;
      el = el.parentElement;
    }
    var pdp = node.closest ? (node.closest("[data-ezink-art-pdp]") || node) : node;
    var sib = pdp.previousElementSibling;
    var guard = 0;
    while (sib && guard < 8) {
      if (sib.id && sib.id.indexOf("ProductSection-") === 0) return sib;
      if (sib.querySelector) {
        var inner = sib.querySelector("[id^='ProductSection-']");
        if (inner) return inner;
      }
      sib = sib.previousElementSibling;
      guard += 1;
    }
    return document.querySelector("[id^='ProductSection-']");
  }

  function selectedColor(section) {
    if (!section) return "";
    var sw = section.querySelector(".ezink-pdp-swatch.is-selected");
    if (sw && sw.getAttribute("data-color")) return sw.getAttribute("data-color");
    var label = section.querySelector("[data-ezink-selected-color]");
    if (label && label.textContent.trim()) return label.textContent.trim();
    var sel = section.querySelector("[data-ezink-color-select]");
    if (sel && sel.value) return sel.value;
    return section.getAttribute("data-active-color") || "";
  }

  function imgUrl(img) {
    if (!img) return "";
    var tpl = img.getAttribute("data-src") || "";
    if (tpl.indexOf("{width}") >= 0) return tpl.replace("{width}", "1200");
    if (tpl && tpl.indexOf("{") < 0) return tpl;
    return img.currentSrc || img.getAttribute("src") || "";
  }

  function colorMedia(section, color) {
    var want = (color || "").toLowerCase();
    var nodes = section ? section.querySelectorAll("[data-product-single-media-wrapper][data-media-color]") : [];
    var views = [];
    var urls = {};
    var i;
    for (i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var c = (el.getAttribute("data-media-color") || "").toLowerCase();
      if (want && c !== want) continue;
      var v = (el.getAttribute("data-media-view") || "").toLowerCase();
      var url = imgUrl(el.querySelector("img"));
      if (!url) continue;
      views.push(v);
      if (!urls[v]) urls[v] = url;
    }
    return { views: views, urls: urls };
  }

  function selectedHex(section, color) {
    var sw = section && section.querySelector(".ezink-pdp-swatch.is-selected");
    var fromSwatch = sw && sw.getAttribute("data-hex");
    if (fromSwatch) return fromSwatch;
    return swatchHex(HANDLE, color);
  }

  function tintImage(img, hex, mid) {
    var w = img.naturalWidth || img.width;
    var h = img.naturalHeight || img.height;
    if (!w || !h) return "";
    var canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    var data = ctx.getImageData(0, 0, w, h);
    var px = data.data;
    var i;
    for (i = 0; i < px.length; i += 4) {
      if (px[i + 3] < 8) continue;
      var rgb = tintChannels(px[i], hex, mid);
      if (!rgb) return "";
      px[i] = rgb[0];
      px[i + 1] = rgb[1];
      px[i + 2] = rgb[2];
    }
    ctx.putImageData(data, 0, 0);
    return canvas.toDataURL("image/png");
  }

  function pickMedia(section, color, view) {
    if (!section) return "";
    var want = (color || "").toLowerCase();
    var nodes = section.querySelectorAll("[data-product-single-media-wrapper][data-media-color]");
    var front = "";
    var any = "";
    var i;
    for (i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var c = (el.getAttribute("data-media-color") || "").toLowerCase();
      if (want && c !== want) continue;
      var v = (el.getAttribute("data-media-view") || "").toLowerCase();
      var url = imgUrl(el.querySelector("img"));
      if (!url) continue;
      if (!any) any = url;
      if ((v.indexOf("front") === 0) && v.indexOf("on-model") < 0 && !front) front = url;
      if (view === "back" && v.indexOf("back") === 0) return url;
      if (view === "side" && v.indexOf("side") === 0) return url;
      if (view === "front" && v.indexOf("front") === 0 && v.indexOf("on-model") < 0) return url;
    }
    return front || any;
  }

  function tightestSize(section) {
    var best = "";
    var bestW = Infinity;
    if (!section) return "M";
    var inputs = section.querySelectorAll("[data-ezink-size-qty-input]");
    inputs.forEach(function (inp) {
      var qty = parseInt(inp.value, 10) || 0;
      if (qty < 1) return;
      var size = normalizeSize(inp.getAttribute("data-size") || "", false);
      var body = BODY[size];
      if (body && body.w < bestW) {
        bestW = body.w;
        best = size;
      }
    });
    return best || "M";
  }

  function locationName(item) {
    var labeled = item.getAttribute("data-art-label");
    if (labeled) return labeled;
    var sel = item.querySelector("[data-ezink-art-loc]");
    return (sel && sel.value) || "Front";
  }

  function fmtIn(n) {
    var v = roundIn(n);
    return (Math.abs(v - Math.round(v)) < 0.05 ? String(Math.round(v)) : v.toFixed(1));
  }

  function ensure(item) {
    if (!item || item.querySelector("[data-ezink-design]")) return;
    var host = document.createElement("div");
    host.className = "ezink-dlab";
    host.setAttribute("data-ezink-design", "");
    host.innerHTML =
      '<button type="button" class="ezink-dlab__open" data-ezink-design-open aria-expanded="false">Design it</button>' +
      '<div class="ezink-dlab__panel" data-ezink-design-panel hidden>' +
      '<div class="ezink-dlab__stage">' +
      '<span class="ezink-dlab__approx" data-ezink-design-approx hidden>Approximate</span>' +
      '<div class="ezink-dlab__fit" data-ezink-design-fit>' +
      '<img class="ezink-dlab__garment" alt="" data-ezink-design-garment>' +
      '<div class="ezink-dlab__grid" data-ezink-design-gridlines hidden></div>' +
      '<span class="ezink-dlab__axis" data-ezink-design-axis hidden></span>' +
      '<div class="ezink-dlab__box" data-ezink-design-box>' +
      '<div class="ezink-dlab__artwrap" data-ezink-design-artwrap hidden>' +
      '<img class="ezink-dlab__art" alt="" draggable="false" data-ezink-design-art>' +
      '<canvas class="ezink-dlab__warp" data-ezink-design-warp hidden></canvas>' +
      '<button type="button" class="ezink-dlab__handle" data-ezink-design-handle aria-label="Scale artwork"></button>' +
      "</div>" +
      '<span class="ezink-dlab__readout" data-ezink-design-readout></span>' +
      "</div></div></div>" +
      '<p class="ezink-dlab__meta" data-ezink-design-meta></p>' +
      '<div class="ezink-dlab__tools">' +
      '<label>Preview size<select data-ezink-design-size></select></label>' +
      '<label>Width<span class="ezink-dlab__inch"><input type="number" min="0.5" step="0.1" inputmode="decimal" data-ezink-design-inches> in</span></label>' +
      '<button type="button" data-ezink-design-center>Center</button>' +
      '<label class="ezink-dlab__check"><input type="checkbox" data-ezink-design-grid> Inch grid</label>' +
      "</div>" +
      '<div class="ezink-dlab__presets">' +
      '<button type="button" data-ezink-preset="3.5">Left chest 3.5 in</button>' +
      '<button type="button" data-ezink-preset="11">Full front 11 in</button>' +
      '<button type="button" data-ezink-preset="max">Full front max</button>' +
      "</div>" +
      '<p class="ezink-dlab__warn" data-ezink-design-dpi hidden></p>' +
      '<p class="ezink-dlab__hint">Vector preferred (SVG, AI, EPS, or PDF), or a high-res transparent PNG.</p>' +
      '<label class="ezink-dlab__file">Upload art' +
      '<input type="file" accept=".svg,.png,.jpg,.jpeg,.webp,.pdf,.ai,.eps,image/png,image/jpeg,image/webp,image/svg+xml" data-ezink-mockup-file data-ezink-design-file>' +
      "</label>" +
      '<p class="ezink-dlab__note" data-ezink-design-note hidden></p>' +
      '<div class="ezink-dlab__actions">' +
      '<button type="button" data-ezink-design-save>Save mockup</button>' +
      '<button type="button" data-ezink-design-close>Close</button>' +
      "</div></div>" +
      '<figure class="ezink-dlab__proof" data-ezink-design-proof hidden>' +
      '<img alt="Approximate mockup" data-ezink-design-thumb>' +
      "<figcaption>" + PROOF_LABEL + "</figcaption>" +
      "</figure>";
    var drop = item.querySelector(".ezink-art__drop");
    if (drop) item.insertBefore(host, drop);
    else item.appendChild(host);
    bind(host, item);
  }

  function bind(host, item) {
    var panel = host.querySelector("[data-ezink-design-panel]");
    var openBtn = host.querySelector("[data-ezink-design-open]");
    var stage = host.querySelector(".ezink-dlab__stage");
    var badge = host.querySelector("[data-ezink-design-approx]");
    var box = host.querySelector("[data-ezink-design-box]");
    var garment = host.querySelector("[data-ezink-design-garment]");
    var wrap = host.querySelector("[data-ezink-design-artwrap]");
    var art = host.querySelector("[data-ezink-design-art]");
    var handle = host.querySelector("[data-ezink-design-handle]");
    var readout = host.querySelector("[data-ezink-design-readout]");
    var meta = host.querySelector("[data-ezink-design-meta]");
    var note = host.querySelector("[data-ezink-design-note]");
    var file = host.querySelector("[data-ezink-design-file]");
    var proof = host.querySelector("[data-ezink-design-proof]");
    var thumb = host.querySelector("[data-ezink-design-thumb]");
    var fit = host.querySelector("[data-ezink-design-fit]");
    var gridEl = host.querySelector("[data-ezink-design-gridlines]");
    var axis = host.querySelector("[data-ezink-design-axis]");
    var warp = host.querySelector("[data-ezink-design-warp]");
    var sizeSel = host.querySelector("[data-ezink-design-size]");
    var inchInput = host.querySelector("[data-ezink-design-inches]");
    var gridToggle = host.querySelector("[data-ezink-design-grid]");
    var dpiEl = host.querySelector("[data-ezink-design-dpi]");
    var state = {
      x: 50, y: 50, wPct: 80, natW: 0, natH: 0, inchW: 0, pxW: 0, pxH: 0,
      vector: false, grid: false, previewSize: "", sizes: [],
      area: null, url: "", tintKey: "", tintUrl: "", wantTint: ""
    };
    var gesture = null;

    function sizeLabels(section) {
      var out = [];
      if (!section) return out;
      var inputs = section.querySelectorAll("[data-ezink-size-qty-input]");
      var i;
      for (i = 0; i < inputs.length; i++) out.push(inputs[i].getAttribute("data-size") || "");
      return out;
    }

    function loadProductChart() {
      if (CHART) return;
      var table = document.querySelector(".ezink-size-chart");
      if (!table) return;
      var headers = [];
      var rows = [];
      var hs = table.querySelectorAll("thead th");
      var i;
      var c;
      for (i = 0; i < hs.length; i++) headers.push(hs[i].textContent || "");
      var trs = table.querySelectorAll("tbody tr");
      for (i = 0; i < trs.length; i++) {
        var cells = trs[i].querySelectorAll("th, td");
        var row = [];
        for (c = 0; c < cells.length; c++) row.push(cells[c].textContent || "");
        rows.push(row);
      }
      if (headers.length) applySpecChart(headers, rows);
    }

    function fillSizeSelect(sizes, current) {
      if (!sizeSel) return;
      var html = "";
      var i;
      for (i = 0; i < sizes.length; i++) {
        var body = bodyFor(sizes[i]);
        html += '<option value="' + sizes[i] + '">' + esc(body.label) + "</option>";
      }
      if (sizeSel.getAttribute("data-built") !== html) {
        sizeSel.innerHTML = html;
        sizeSel.setAttribute("data-built", html);
      }
      sizeSel.value = current;
      sizeSel.title = specSource();
    }

    function setNote(text) {
      if (!note) return;
      note.hidden = !text;
      note.textContent = text || "";
    }

    function syncInches(fitted) {
      state.inchW = fitted.w;
      if (state.area && state.area.w > 0) state.wPct = (fitted.w / state.area.w) * 100;
      if (inchInput && document.activeElement !== inchInput) {
        inchInput.value = fitted.w.toFixed(1);
        inchInput.max = state.area ? String(state.area.w) : "16.5";
      }
    }

    function applyDpi(hIn) {
      if (!dpiEl) return;
      var msg = state.natW > 0 ? lowResWarning(state.pxW, state.inchW, state.vector) : "";
      if (!msg && state.natW > 0 && hIn > 0) msg = lowResWarning(state.pxH, hIn, state.vector);
      dpiEl.hidden = !msg;
      dpiEl.textContent = msg || "";
    }

    function applyGrid() {
      if (!gridEl) return;
      if (!state.grid || !state.area || !(state.area.w > 0)) {
        gridEl.hidden = true;
        return;
      }
      var boxPx = box.clientWidth;
      if (!(boxPx > 0)) {
        gridEl.hidden = true;
        return;
      }
      var inch = boxPx / state.area.w;
      var origin = fit || stage;
      var originRect = origin.getBoundingClientRect();
      var boxRect = box.getBoundingClientRect();
      gridEl.hidden = false;
      gridEl.style.backgroundSize = inch.toFixed(2) + "px " + inch.toFixed(2) + "px";
      gridEl.style.backgroundPosition = (boxRect.left - originRect.left).toFixed(1) + "px " + (boxRect.top - originRect.top).toFixed(1) + "px";
    }

    function applyWarp() {
      if (!warp) return;
      var key = state.area ? state.area.key : "";
      var theta = 0;
      if (shouldWarp(key) && state.natW > 0 && art.naturalWidth && state.inchW > 0) {
        theta = warpTheta(state.inchW, bodyFor(state.area.size).w);
      }
      if (!(theta > 0) || wrap.clientWidth < 8 || wrap.clientHeight < 8) {
        wrap.classList.remove("is-warped");
        warp.hidden = true;
        return;
      }
      var dpr = Math.min((window.devicePixelRatio || 1), 2);
      var w = Math.max(2, Math.round(wrap.clientWidth * dpr));
      var h = Math.max(2, Math.round(wrap.clientHeight * dpr));
      if (warp.width !== w) warp.width = w;
      if (warp.height !== h) warp.height = h;
      try {
        paintWarp(warp, art, theta);
        warp.hidden = false;
        wrap.classList.add("is-warped");
      } catch (err) {
        wrap.classList.remove("is-warped");
        warp.hidden = true;
      }
    }

    function applyArt() {
      if (!state.area) return;
      var fitted = null;
      if (state.natW > 0 && state.inchW > 0) {
        fitted = fitInches(state.inchW, state.natW, state.natH, state.area.w, state.area.h);
        syncInches(fitted);
      }
      var boxW = box.clientWidth || 0;
      var boxH = box.clientHeight || 0;
      if (state.natW > 0 && boxW > 0 && boxH > 0) {
        var placed = clampPlacement(boxW, boxH, state.natW, state.natH, state.x, state.y, state.wPct, 0.02);
        state.x = placed.x;
        state.y = placed.y;
        state.wPct = placed.wPct;
        if (state.area.w > 0) {
          fitted = fitInches(widthInches(state.wPct, state.area.w), state.natW, state.natH, state.area.w, state.area.h);
          syncInches(fitted);
        }
      }
      wrap.style.left = state.x + "%";
      wrap.style.top = state.y + "%";
      wrap.style.width = state.wPct + "%";
      if (state.natW > 0 && fitted) {
        readout.textContent = fitted.w.toFixed(1) + " x " + fitted.h.toFixed(1) + " in";
        applyDpi(fitted.h);
      } else {
        readout.textContent = fmtIn(state.area.w) + " x " + fmtIn(state.area.h) + " in max";
        applyDpi(0);
      }
      applyGrid();
      applyWarp();
    }

    function setApproximate(on) {
      if (stage) stage.classList.toggle("is-approximate", !!on);
      if (badge) badge.hidden = !on;
    }

    function showGarment(url, alt, cors) {
      if (!url) {
        state.url = "";
        garment.removeAttribute("src");
        garment.alt = "Garment photo unavailable";
        return;
      }
      if (url === state.url) {
        garment.alt = alt;
        return;
      }
      state.url = url;
      garment.alt = alt;
      garment.onerror = function () {
        garment.onerror = null;
        if (garment.crossOrigin) {
          garment.removeAttribute("crossorigin");
          garment.src = url;
        }
      };
      if (cors && /^https?:/i.test(url)) garment.crossOrigin = "anonymous";
      else garment.removeAttribute("crossorigin");
      garment.onload = function () { applyArt(); };
      garment.src = url;
    }

    function paintTemplate(tmpl, hex) {
      var mid = (SLEEVE_STYLES[HANDLE] && SLEEVE_STYLES[HANDLE].shadeMid) || 208;
      var key = tmpl.url + "|" + (hex || "");
      state.wantTint = key;
      if (!hex) {
        showGarment(tmpl.url, "Approximate sleeve", true);
        return;
      }
      if (state.tintKey === key && state.tintUrl) {
        showGarment(state.tintUrl, "Approximate sleeve", false);
        return;
      }
      var probe = new Image();
      probe.crossOrigin = "anonymous";
      probe.onload = function () {
        if (state.wantTint !== key) return;
        var tinted = "";
        try {
          tinted = tintImage(probe, hex, mid);
        } catch (err) {
          tinted = "";
        }
        if (state.wantTint !== key) return;
        if (!tinted) {
          showGarment(tmpl.url, "Approximate sleeve", true);
          return;
        }
        state.tintKey = key;
        state.tintUrl = tinted;
        showGarment(tinted, "Approximate sleeve", false);
      };
      probe.onerror = function () {
        if (state.wantTint !== key) return;
        showGarment(tmpl.url, "Approximate sleeve", true);
      };
      probe.src = tmpl.url;
    }

    function layout() {
      loadProductChart();
      var section = sectionOf(item);
      var sizes = offeredSizes(sizeLabels(section), false);
      if (!sizes.length) sizes = offeredSizes(["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"], false);
      state.sizes = sizes;
      if (!state.previewSize || sizes.indexOf(state.previewSize) < 0) {
        state.previewSize = defaultPreviewSize(sizes);
      }
      fillSizeSelect(sizes, state.previewSize);
      var area = printArea(state.previewSize, locationName(item), { youth: false });
      state.area = area;
      var body = bodyFor(area.size);
      var side = area.key === "left sleeve" ? "left" : area.key === "right sleeve" ? "right" : "";
      var color = selectedColor(section);
      var media = colorMedia(section, color);
      var choice = side ? chooseSleeve(HANDLE, side, media.views) : { kind: "none" };
      var geom = side && choice.kind !== "none" ? sleeveGeom(HANDLE, side, choice.kind) : null;
      var approximate = choice.kind === "template";
      if (fit) {
        var ref = referenceWidth(sizes);
        var scale = side ? 1 : shirtScale(body.w, ref);
        fit.style.width = (Math.round(scale * 1000) / 10) + "%";
      }
      if (geom) {
        var placed = sleeveBox(area.size, area.w, area.h, geom);
        box.style.width = placed.widthPct + "%";
        box.style.left = placed.left + "%";
        box.style.top = placed.top + "%";
      } else {
        var anchor = ANCHOR[area.anchor] || ANCHOR.front;
        var widthPct = (area.w / body.w) * TORSO_FRAC * 100;
        box.style.width = widthPct + "%";
        box.style.left = (anchor.cx - widthPct / 2) + "%";
        box.style.top = anchor.top + "%";
      }
      box.style.aspectRatio = area.w + " / " + area.h;
      setApproximate(approximate);
      meta.textContent = "Print area " + fmtIn(area.w) + " × " + fmtIn(area.h) + " in"
        + (color ? " · " + color : "")
        + " · " + area.sizeLabel
        + (approximate ? " · Approximate" : "");
      if (choice.kind === "photo") {
        state.wantTint = "";
        showGarment(media.urls[choice.view] || "", (color || "Garment") + " " + (choice.view || "side"), true);
      } else if (choice.kind === "template") {
        var tmpl = SLEEVE_STYLES[HANDLE] && SLEEVE_STYLES[HANDLE][side];
        if (tmpl) paintTemplate(tmpl, selectedHex(section, color));
        else showGarment("", "", false);
      } else {
        state.wantTint = "";
        showGarment(pickMedia(section, color, area.view), (color || "Garment") + " " + area.view, true);
      }
      requestAnimationFrame(applyArt);
    }

    function openPanel(on) {
      panel.hidden = !on;
      openBtn.setAttribute("aria-expanded", on ? "true" : "false");
      if (on) layout();
    }

    openBtn.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      openPanel(panel.hidden);
    });
    host.querySelector("[data-ezink-design-close]").addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      openPanel(false);
    });

    var locSel = item.querySelector("[data-ezink-art-loc]");
    if (locSel) locSel.addEventListener("change", function () {
      if (!panel.hidden) layout();
    });

    file.addEventListener("change", function () {
      var picked = file.files && file.files[0];
      if (!picked) return;
      var name = String(picked.name || "").toLowerCase();
      var previewable = /\.(svg|png|jpe?g|webp)$/.test(name) || /^image\/(png|jpeg|webp|svg\+xml)/.test(picked.type || "");
      if (!previewable) {
        setNote("Preview needs an SVG or a high-res transparent PNG. AI, EPS, and PDF are not drawn on the shirt here.");
        return;
      }
      setNote("");
      state.vector = /\.svg$/.test(name) || String(picked.type || "").indexOf("svg") >= 0;
      if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
      state.objectUrl = URL.createObjectURL(picked);
      var probe = new Image();
      probe.onload = function () {
        state.natW = probe.naturalWidth || probe.width || 300;
        state.natH = probe.naturalHeight || probe.height || 300;
        state.pxW = state.vector ? 0 : (probe.naturalWidth || 0);
        state.pxH = state.vector ? 0 : (probe.naturalHeight || 0);
        state.x = garmentCenterX(state.previewSize || "M", locationName(item));
        state.y = 45;
        if (!(state.inchW > 0) && state.area) state.inchW = state.area.w * 0.8;
        art.src = state.objectUrl;
        wrap.hidden = false;
        applyArt();
      };
      probe.onerror = function () {
        setNote("That file did not open in the browser. Use an SVG or a transparent PNG for the preview.");
      };
      probe.src = state.objectUrl;
    });

    function pointBox(evt) {
      var rect = box.getBoundingClientRect();
      return {
        rect: rect,
        px: rect.width ? ((evt.clientX - rect.left) / rect.width) * 100 : 50,
        py: rect.height ? ((evt.clientY - rect.top) / rect.height) * 100 : 50
      };
    }

    wrap.addEventListener("pointerdown", function (evt) {
      if (wrap.hidden) return;
      evt.preventDefault();
      evt.stopPropagation();
      var scaling = evt.target === handle || (evt.target.closest && evt.target.closest("[data-ezink-design-handle]"));
      var p = pointBox(evt);
      gesture = {
        mode: scaling ? "scale" : "move",
        ox: p.px - state.x,
        oy: p.py - state.y,
        wPct: state.wPct,
        dist: Math.hypot(evt.clientX - (p.rect.left + p.rect.width * state.x / 100), evt.clientY - (p.rect.top + p.rect.height * state.y / 100)) || 1
      };
      try { wrap.setPointerCapture(evt.pointerId); } catch (err) {}
    });
    wrap.addEventListener("pointermove", function (evt) {
      if (!gesture) return;
      var p = pointBox(evt);
      if (gesture.mode === "move") {
        state.x = p.px - gesture.ox;
        state.y = p.py - gesture.oy;
        var center = garmentCenterX(state.previewSize || "M", locationName(item));
        var band = state.area ? snapBandPct(state.area.w) : 3;
        if (Math.abs(state.x - center) <= band) {
          state.x = center;
          if (axis && state.area && state.area.key.indexOf("sleeve") < 0) axis.hidden = false;
        } else if (axis) axis.hidden = true;
      } else {
        var cx = p.rect.left + p.rect.width * state.x / 100;
        var cy = p.rect.top + p.rect.height * state.y / 100;
        var dist = Math.hypot(evt.clientX - cx, evt.clientY - cy);
        state.wPct = gesture.wPct * (dist / gesture.dist);
        if (state.area && state.area.w > 0) state.inchW = widthInches(state.wPct, state.area.w);
      }
      applyArt();
    });
    function endGesture() {
      gesture = null;
      if (axis) axis.hidden = true;
    }
    wrap.addEventListener("pointerup", endGesture);
    wrap.addEventListener("pointercancel", endGesture);

    host.querySelector("[data-ezink-design-save]").addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (wrap.hidden || !art.getAttribute("src")) {
        setNote("Upload an SVG or a transparent PNG, then place it on the garment.");
        return;
      }
      if (!garment.naturalWidth) {
        setNote("The garment photo is still loading.");
        return;
      }
      try {
        var canvas = document.createElement("canvas");
        canvas.width = garment.naturalWidth;
        canvas.height = garment.naturalHeight;
        var ctx = canvas.getContext("2d");
        /* Garment photo and artwork only. Do not stroke the print area. */
        ctx.drawImage(garment, 0, 0, canvas.width, canvas.height);
        var gRect = garment.getBoundingClientRect();
        var visual = (wrap.classList.contains("is-warped") && warp && !warp.hidden) ? warp : art;
        var aRect = visual.getBoundingClientRect();
        if (!gRect.width || !gRect.height) throw new Error("layout");
        var sx = canvas.width / gRect.width;
        var sy = canvas.height / gRect.height;
        ctx.drawImage(
          visual,
          (aRect.left - gRect.left) * sx,
          (aRect.top - gRect.top) * sy,
          aRect.width * sx,
          aRect.height * sy
        );
        var png = canvas.toDataURL("image/png");
        thumb.src = png;
        proof.hidden = false;
        item.setAttribute("data-ezink-design-saved", "1");
        setNote("");
      } catch (err) {
        setNote("Could not save a PNG from this photo. The placement stays in the panel.");
      }
    });

    if (sizeSel) sizeSel.addEventListener("change", function () {
      state.previewSize = sizeSel.value;
      layout();
    });
    if (inchInput) {
      inchInput.addEventListener("input", function () {
        var v = parseFloat(inchInput.value);
        if (!(v > 0)) return;
        state.inchW = v;
        applyArt();
      });
      inchInput.addEventListener("keydown", function (evt) {
        if (evt.key === "Enter") evt.preventDefault();
      });
    }
    var centerBtn = host.querySelector("[data-ezink-design-center]");
    if (centerBtn) centerBtn.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      state.x = garmentCenterX(state.previewSize || "M", locationName(item));
      if (axis && state.area && state.area.key.indexOf("sleeve") < 0) {
        axis.hidden = false;
        setTimeout(function () { if (!gesture) axis.hidden = true; }, 700);
      }
      applyArt();
    });
    if (gridToggle) gridToggle.addEventListener("change", function () {
      state.grid = !!gridToggle.checked;
      applyArt();
    });
    host.querySelectorAll("[data-ezink-preset]").forEach(function (btn) {
      btn.addEventListener("click", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var key = btn.getAttribute("data-ezink-preset");
        var front = printArea(state.previewSize || "M", "Front", { youth: false });
        state.inchW = key === "max" ? front.w : parseFloat(key);
        applyArt();
      });
    });

    host._ezinkLayout = layout;
    if (!panel.hidden) layout();
  }

  function scan() {
    var pdps = document.querySelectorAll("[data-ezink-art-pdp]");
    pdps.forEach(function (pdp) {
      if (!isTarget(pdp)) return;
      pdp.querySelectorAll("[data-ezink-art-item]").forEach(ensure);
    });
  }

  function relayoutOpen() {
    document.querySelectorAll("[data-ezink-design-panel]:not([hidden])").forEach(function (panel) {
      var host = panel.closest("[data-ezink-design]");
      if (host && host._ezinkLayout) host._ezinkLayout();
    });
  }

  api.scan = scan;

  document.addEventListener("ezink-art-items-change", function () {
    setTimeout(scan, 0);
  });
  document.addEventListener("click", function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    if (t.closest("[data-ezink-art-add]")) setTimeout(scan, 0);
    if (t.closest(".ezink-pdp-swatch, [data-ezink-color-select]")) setTimeout(relayoutOpen, 60);
  });
  document.addEventListener("input", function (evt) {
    var t = evt.target;
    if (t && t.matches && t.matches("[data-ezink-size-qty-input]")) relayoutOpen();
  });
  document.addEventListener("change", function (evt) {
    var t = evt.target;
    if (!t || !t.matches) return;
    if (t.matches("[data-ezink-art-loc], [data-ezink-color-select], [data-ezink-size-qty-input]")) {
      setTimeout(relayoutOpen, 0);
    }
  });

  window.addEventListener("resize", function () { relayoutOpen(); });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
})(typeof window !== "undefined" ? window : globalThis);
